// @flow
import React from "react";
import ClientConfig from "../../context/clientConfig";
import i18n from "../../../i18n";
import classnames from "classnames"; 

const HeaderWithImage = () => (
  <ClientConfig.Consumer>
    {clientConfig => {
      const { headerImage, headerImageAlt,headerImageClassNames, customNS } = clientConfig;
      return (
        <div className="client-header d-flex justify-content-center">
          <div className={classnames(
          `${headerImageClassNames || ""} flex-fill align-content-center`
          )}>
            <img className="img-fluid header-image" src={headerImage} alt={i18n.t(headerImageAlt, {ns: customNS})} />
          </div>
        </div>
      );
    }}
  </ClientConfig.Consumer>
);

export default HeaderWithImage;
